<script>
import {defineComponent} from 'vue'
import {Link} from "@inertiajs/vue3";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import "swiper/css";
import 'swiper/css/pagination'

export default defineComponent({
    name: "HomeCategoryLinks",
    components: {
        OnlyMobile,
        OnlyDesktop,
        Link,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            swiper: null,
        }
    },
    methods: {
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance;
        },
    },
})
</script>

<template>
    <OnlyDesktop :maxSize="480">
        <div class="grid grid-cols-2 md:grid-cols-2 gap-4">
            <Link :href="route('catalog',{category_title:'plitka'})"
                  class="bg-grayBg plitka-bg bg-no-repeat bg-contain border-2 border-gray-100 rounded-lg px-2 md:px-4 py-4 relative md:hover:shadow-sm md:hover:border-baseColor max-md:active:border-baseColor transition">
                <div class="w-full h-full">
                    <p class="mb-4 font-semibold leading-tight">
                        Плитка
                    </p>
                    <p class="md:text-gray-800 text-xs md:text-sm font-medium md:font-normal md:max-w-[80%]">
                        Качественная плитка для пола и стен в любом интерьере.
                    </p>
                </div>
            </Link>
            <Link :href="route('catalog',{category_title:'keramogranit'})"
                  class="bg-grayBg keramogranit-bg bg-no-repeat bg-contain border-2 border-gray-100 rounded-lg px-2 md:px-4 py-4 relative md:hover:shadow-sm md:hover:border-baseColor max-md:active:border-baseColor transition">
                <div class="w-full h-full">
                    <p class="mb-4 font-semibold leading-tight">
                        Керамогранит
                    </p>
                    <p class="md:text-gray-800 text-xs md:text-sm font-medium md:font-normal md:max-w-[80%]">
                        Надёжный керамогранит для помещений, улицы и фасадов.
                    </p>
                </div>
            </Link>
            <Link :href="route('catalog',{category_title:'mozaika'})"
                  class="bg-grayBg mozaika-bg bg-no-repeat bg-contain border-2 border-gray-100 rounded-lg px-2 md:px-4 py-4 relative md:hover:shadow-sm md:hover:border-baseColor max-md:active:border-baseColor transition">
                <div class="w-full h-full">
                    <p class="mb-4 font-semibold leading-tight">
                        Мозаика
                    </p>
                    <p class="md:text-gray-800 text-xs md:text-sm font-medium md:font-normal md:max-w-[80%]">
                        Декоративная мозаика для кухни, ванной и акцентных зон.
                    </p>
                </div>
            </Link>
            <Link :href="route('catalog',{category_title:'stupeni'})"
                  class="bg-grayBg stupeni_50-bg bg-no-repeat bg-contain border-2 border-gray-100 rounded-lg px-2 md:px-4 py-4 relative md:hover:shadow-sm md:hover:border-baseColor max-md:active:border-baseColor transition">
                <div class="w-full h-full">
                    <p class="mb-4 font-semibold leading-tight">
                        Ступени
                    </p>
                    <p class="md:text-gray-800 text-xs md:text-sm font-medium md:font-normal md:max-w-[80%]">
                        Ступени из прочной плитки — практично и безопасно.
                    </p>
                </div>
            </Link>
            <Link :href="route('catalog',{category_title:'iskustvenniy_kamen'})"
                  class="bg-grayBg iskustvenniy-kamen-bg bg-no-repeat bg-contain border-2 border-gray-100 rounded-lg px-2 md:px-4 py-4 relative md:hover:shadow-sm md:hover:border-baseColor max-md:active:border-baseColor transition">
                <div class="w-full h-full">
                    <p class="mb-4 font-semibold leading-tight">
                        Искусственный <br class="block md:hidden"/> камень
                    </p>
                    <p class="md:text-gray-800 text-xs md:text-sm font-medium md:font-normal md:max-w-[80%]">
                        Эстетичный и прочный камень для отделки любых поверхностей.
                    </p>
                </div>
            </Link>
            <Link :href="route('catalog',{category_title:'klinkernaya_plitka'})"
                  class="bg-grayBg klinkernaya_plitka-bg bg-no-repeat bg-contain border-2 border-gray-100 rounded-lg px-2 md:px-4 py-4 relative md:hover:shadow-sm md:hover:border-baseColor max-md:active:border-baseColor transition">
                <div class="bg-no-repeat w-full h-full">
                    <p class="mb-4 font-semibold leading-tight">
                        Клинкерная <br class="block md:hidden"/> плитка
                    </p>
                    <p class="md:text-gray-800 text-xs md:text-sm font-medium md:font-normal md:max-w-[80%]">
                        Износостойкая плитка для цоколей, лестниц и фасадов.
                    </p>
                </div>
            </Link>
        </div>
    </OnlyDesktop>
    <OnlyMobile :maxSize="480">
        <div class="w-full overflow-hidden">
            <Swiper :slides-per-view="'auto'" :space-between="18" class="!overflow-visible cursor-grab">
                <SwiperSlide class="!w-auto">
                    <Link :href="route('catalog',{category_title:'plitka'})"
                          class="flex flex-col gap-2 items-center font-semibold text-xs text-center leading-tight">
                        <img src="@img/category_icons/mobile/plitka.webp" alt="plitka"
                             class="w-12 h-12 rounded-lg object-contain"/>
                        Плитка
                    </Link>
                </SwiperSlide>
                <SwiperSlide class="!w-auto">
                    <Link :href="route('catalog',{category_title:'keramogranit'})"
                          class="flex flex-col gap-2 items-center font-semibold text-xs text-center leading-tight">
                        <img src="@img/category_icons/mobile/keramogranit.webp" alt="keramogranit"
                             class="w-12 h-12 rounded-lg object-contain"/>
                        Керамогранит
                    </Link>
                </SwiperSlide>
                <SwiperSlide class="!w-auto">
                    <Link :href="route('catalog',{category_title:'mozaika'})"
                          class="flex flex-col gap-2 items-center font-semibold text-xs text-center leading-tight">
                        <img src="@img/category_icons/mobile/mozaika.webp" alt="mozaika"
                             class="w-12 h-12 rounded-lg object-contain"/>
                        Мозайка
                    </Link>
                </SwiperSlide>
                <SwiperSlide class="!w-auto">
                    <Link :href="route('catalog',{category_title:'iskustvenniy_kamen'})"
                          class="flex flex-col gap-2 items-center font-semibold text-xs text-center leading-tight">
                        <img src="@img/category_icons/mobile/iskusstvenniy_kamen.webp" alt="iskusstvenniy_kamen"
                             class="w-12 h-12 rounded-lg object-contain"/>
                        Искусственный <br/>камень
                    </Link>
                </SwiperSlide>
                <SwiperSlide class="!w-auto">
                    <Link :href="route('catalog',{category_title:'klinkernaya_plitka'})"
                          class="flex flex-col gap-2 items-center font-semibold text-xs text-center leading-tight">
                        <img src="@img/category_icons/mobile/klinker.webp" alt="klinker"
                             class="w-12 h-12 rounded-lg object-contain"/>
                        Клинкерная <br/>плитка
                    </Link>
                </SwiperSlide>
                <SwiperSlide class="!w-auto">
                    <Link :href="route('catalog',{category_title:'stupeni'})"
                          class="flex flex-col gap-2 items-center font-semibold text-xs text-center leading-tight">
                        <img src="@img/category_icons/mobile/stupen.webp" alt="stupen"
                             class="w-12 h-12 rounded-lg object-contain"/>
                        Ступени
                    </Link>
                </SwiperSlide>
            </Swiper>
        </div>
    </OnlyMobile>
</template>

<style scoped lang="scss">

@media (min-width: 480px) {
    .plitka-bg {
        background-image: url("@img/category_icons/images/plitki.webp");
        background-position: calc(100% + 61px) center;
    }

    .keramogranit-bg {
        background-image: url("@img/category_icons/images/keramigranit.webp");
        background-position: calc(100% + 61px) center;
    }

    .mozaika-bg {
        background-image: url("@img/category_icons/images/mozaika.webp");
        background-position: calc(100% + 61px) center;
    }

    .iskustvenniy-kamen-bg {
        background-image: url("@img/category_icons/images/iskusstvenniy_kamen.webp");
        background-position: calc(100% + 61px) center;
    }

    .klinkernaya_plitka-bg {
        background-image: url("@img/category_icons/images/klinker.webp");
        background-position: calc(100% + 61px) center;
    }

    .stupeni_50-bg {
        background-image: url("@img/category_icons/images/stupen.webp");
        background-position: calc(100% + 61px) center;
    }
}

@media (max-width: 480px) {
    .iskustvenniy-kamen-bg {
        background-position: calc(100% + 80px) center;
    }

    .klinkernaya_plitka-bg {
        background-position: calc(100% + 80px) center;
    }
}
</style>
